import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {ConversionLogModuleName} from "../utils/names/optionalModuleNames";
import {ConversionLogControllerName} from "../utils/names/serviceNames";
import {getTabName} from "modules/utils/TabNameUtils";

export const ConversionLogModuleConfiguration = new RestrictedRouteModuleConfiguration(
    ConversionLogModuleName,
    [
        ConversionLogModuleName,
    ],
    [
        ["/conversion/log", {
            template: require('./route/conversion-log.controller.html'),
            controller: ConversionLogControllerName,
            reloadOnSearch: false
        }]
    ],
    [],
    [ConversionLogModuleName],
    [UserGranredAuthorityName.STATISTICS],
    getTabName() + '| Conversion Report Log'
);

export default ConversionLogModuleConfiguration;